// extracted by extract-css-chunks-webpack-plugin
module.exports = {"vtoContainer":"_5NWS8","virtualTryOnText":"_-6J7o","virtualTryOnMessageContainer":"DECcY"};